import { GripVertical } from "lucide-react"
import { Group, Panel, Separator } from "react-resizable-panels"

import { cn } from "@/lib/utils"

const ResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentProps<typeof Group>) => (
  <Group className={cn("h-full w-full", className)} {...props} />
)

const ResizablePanel = Panel

type ResizableHandleProps = React.ComponentProps<typeof Separator> & {
  withHandle?: boolean
  /**
   * Orientation of the parent Group. Determines the handle line direction:
   * - "horizontal" group (row layout) -> vertical line between panels
   * - "vertical" group (column layout) -> horizontal line between panels
   */
  orientation?: "horizontal" | "vertical"
}

const ResizableHandle = ({
  withHandle,
  className,
  orientation = "horizontal",
  ...props
}: ResizableHandleProps) => {
  const isRow = orientation === "horizontal"
  return (
    <Separator
      className={cn(
        "relative flex items-center justify-center bg-border transition-colors hover:bg-primary/50 active:bg-primary/70",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        isRow
          ? "w-1.5 cursor-col-resize"
          : "h-1.5 w-full cursor-row-resize",
        className
      )}
      {...props}
    >
      {withHandle && (
        <div
          className={cn(
            "z-10 flex items-center justify-center rounded-sm border bg-border",
            isRow ? "h-4 w-3" : "h-3 w-4"
          )}
        >
          <GripVertical className={cn("h-2.5 w-2.5", !isRow && "rotate-90")} />
        </div>
      )}
    </Separator>
  )
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle }
